var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"勤怠・経費申請の決裁","icon":"fas fa-stamp"}},[_c('base-error-guard',[_c('release-workflow-alert',{attrs:{"simple-alert":""}}),_c('workflow-search')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }